import { render, staticRenderFns } from "./CreateLiquidity.vue?vue&type=template&id=655d5aaf&scoped=true&"
import script from "./CreateLiquidity.vue?vue&type=script&lang=js&"
export * from "./CreateLiquidity.vue?vue&type=script&lang=js&"
import style0 from "./CreateLiquidity.vue?vue&type=style&index=0&id=655d5aaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d5aaf",
  null
  
)

export default component.exports